/**
 * The signed-in account, held by this context.
 *
 * A SINGLETON, and where session state belongs once the legacy store is gone. Until then
 * `store/auth`'s `setUserDetails` records every change here, a documented exception: the store is the
 * only writer, and only through that setter. When the store goes, sign-in writes here directly and
 * that call is deleted.
 */
let signedIn = null;

/** @param {Object|null|undefined} account - the account document, or empty when signed out */
export const recordSignedInAccount = (account) => {
  signedIn = account ?? null;
};

export const signedInAccount = () => signedIn;

/** The zone of the device in use. */
export const deviceTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
